// extracted by mini-css-extract-plugin
module.exports = {"c-card":"Card_c-card__1Smxe","c-card__description":"Card_c-card__description__jrQvx","c-card__num":"Card_c-card__num__29tSA"};